import React from 'react';
import { CheckCircle } from 'lucide-react';
import MetaTags from '../components/MetaTags';
import { getBreadcrumbSchema } from '../utils/schemaGenerator';
import '../components/css/Pricing.css';

const Pricing = () => {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Pricing', url: '/pricing' }
  ]);

  return (
    <div className="pricing-page">
      <MetaTags
        title="Pricing Plans & Subscriptions | BookMyAudition"
        description="Transparent pricing for performers and casting professionals. Choose the right plan to access audition calls, AI tools, and casting services."
        keywords="BookMyAudition pricing, actor subscription plan, casting director pricing, audition booking cost"
        canonical="https://web.bookmyaudition.com/pricing"
        schema={breadcrumbSchema}
      />
      
      {/* --- HERO SECTION --- */}
      <section className="pricing-header text-center">
        <div className="container">
          <h1 className="mb-3">Simple, Transparent Pricing</h1>
          <p className="text-muted fs-5">Choose the plan that works best for you. No hidden fees, cancel anytime.</p>
        </div>
      </section>

      {/* --- PRICING CARDS SECTION --- */}
      <section className="pricing-card">
        <div className="container">
          <div className="row g-4 align-items-center">
            
            {/* 1. FREE PLAN */}
            <div className="col-lg-4 col-md-4">
              <div className="price-card">
                <h3>Free</h3>
                <div className="mb-2">
                    <span className="price-value">$0</span>
                    <span className="price-month">/month</span>
                </div>
                <p className="text-muted small">Perfect for getting started</p>
                <ul className="feature-list-pricing">
                  <li><CheckCircle size={16} className="text-success" /> Browse all roles</li>
                  <li><CheckCircle size={16} className="text-success" /> Apply to up to 5 roles/month</li>
                  <li><CheckCircle size={16} className="text-success" /> Basic profile</li>
                  <li><CheckCircle size={16} className="text-success" /> Email notifications</li>
                </ul>
                <button className="btn btn-pricing-outline">Get Started</button>
              </div>
            </div>

            {/* 2. PRO PLAN (POPULAR) */}
            <div className="col-lg-4 col-md-4">
              <div className="price-card featured position-relative">
                <span className="badge badge-popular position-absolute top-0 end-0 m-3">POPULAR</span>
                <h3>Pro</h3>
                <div className="mb-2">
                    <span className="price-value">$29</span>
                    <span className="price-month">/month</span>
                </div>
                <p className="text-muted small">For serious talent</p>
                <ul className="feature-list-pricing">
                  <li><CheckCircle size={16} className="text-success" /> Unlimited applications</li>
                  <li><CheckCircle size={16} className="text-success" /> Featured profile status</li>
                  <li><CheckCircle size={16} className="text-success" /> Priority audition booking</li>
                  <li><CheckCircle size={16} className="text-success" /> Direct casting messaging</li>
                  <li><CheckCircle size={16} className="text-success" /> Video portfolio hosting</li>
                </ul>
                <button className="btn btn-pricing-primary">Upgrade to Pro</button>
              </div>
            </div>

            {/* 3. CASTING PRO PLAN */}
            <div className="col-lg-4 col-md-4">
              <div className="price-card">
                <h3>Casting Pro</h3>
                <div className="mb-2">
                    <span className="price-value">$99</span>
                    <span className="price-month">/month</span>
                </div>
                <p className="text-muted small">For casting directors & producers</p>
                <ul className="feature-list-pricing">
                  <li><CheckCircle size={16} className="text-success" /> Post unlimited roles</li>
                  <li><CheckCircle size={16} className="text-success" /> AI-powered talent matching</li>
                  <li><CheckCircle size={16} className="text-success" /> Smart scheduling tools</li>
                  <li><CheckCircle size={16} className="text-success" /> Virtual audition rooms</li>
                  <li><CheckCircle size={16} className="text-success" /> Team collaboration</li>
                </ul>
                <button className="btn btn-pricing-outline">Contact Sales</button>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Pricing;